module.exports = __webpack_public_path__ + "img/arrow_to.c70fc491.png";